import { onBeforeUnmount, onMounted, ref } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

export function useUnsavedChangesGuard({ isDirty, save }) {
  const dialogRef = ref(null);
  let resolveLeave = null;
  let saving = false;

  const finish = allowed => {
    const resolve = resolveLeave;
    resolveLeave = null;
    saving = false;
    dialogRef.value?.close();
    resolve?.(allowed);
  };

  onBeforeRouteLeave(() => {
    if (!isDirty.value) return true;

    return new Promise(resolve => {
      resolveLeave = resolve;
      dialogRef.value?.open();
    });
  });

  const confirmSave = async () => {
    if (saving || !resolveLeave) return;
    saving = true;
    try {
      await save();
      finish(true);
    } catch {
      finish(false);
    }
  };

  const discard = () => {
    if (saving) return;
    finish(true);
  };
  const stay = () => {
    if (!resolveLeave || saving) return;
    finish(false);
  };

  const onBeforeUnload = event => {
    if (!isDirty.value) return;
    event.preventDefault();
    event.returnValue = '';
  };

  onMounted(() => window.addEventListener('beforeunload', onBeforeUnload));
  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', onBeforeUnload);
    resolveLeave?.(false);
  });

  return { dialogRef, confirmSave, discard, stay };
}
